<template>
    <div  style="margin: 5px">
        <div class="row" >
                <div class="col-md-10 col-9">
                    <h4 class="font-weight-normal">
                        {{ $t('closesellDetail') }}
                    </h4 >
                </div>
                <div class="col-md-2 col-3 text-right align-text-center">
                    <a  @click="$router.go(-1)">
                    <CButton>
                        <span><i class="fi fi-rr-arrow-left mr-2" style="position: relative; top: 2px;"></i></span>{{ $t('back') }}
                    </CButton>
                    </a>
                </div>
        </div>
        <CCard>
            <CCardBody>
                <div class="row">
                    <div class="col-7 col-lg-10">
                    <h5 class="font-weight-normal">
                        {{ $t('information') }}
                    </h5>
                    </div>
                    <div v-if="isExport" class="justify-content-end col-lg-2 col-5">
                    <CButton  v-on:click="exportReport()" block color="info">
                        <img src="/img/file-excel.png" alt="Excel Icon" style="width: 16px; height: 16px; margin-right: 8px; vertical-align: middle; position: relative; top: -2px;" />  {{ $t('export') }}
                    </CButton>
                    </div>
                </div>
                <CRow class="mt-3 mb-0">
                   
                    <CCol lg="6" md="6" col="12">
                        <CRow >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ $t('roundNo') }} :</p>
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ closeSellData.roundNo }}</p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ $t('orderMachine') }} :</p> 
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                {{ closeSellData.pos.posNumber || '-' }}
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ $t('openAt') }} :</p>
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{getFormatDate(closeSellData.openAt) || '-'}}</p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ $t('openBy') }} :</p> 
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{closeSellData.created_by.username || '-'}}</p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ $t('closeAt') }}  :</p> 
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{getFormatDate(closeSellData.closeAt) || '-'}}</p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow  >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0"> {{ $t('closeBy') }} :</p>
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{closeSellData.created_by.username}}</p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">{{ $t('taxInvoiceReceipt') }}  :</p> 
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0"> - </p>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="6" md="6" col="12">
                        <CRow  >
                            <CCol col="5" class="text-right col-form-label text-md-right text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0"> {{ $t('billAmount') }} :</p>
                            </CCol>
                            <CCol col="7" class="col-form-label text-left text-dark w-100 w-sm-auto">
                                <p class="mb-0">3</p>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>               
            </CCardBody>
        </CCard>
        <CRow class="align-items-stretch">
            <CCol lg="4" md="4">
                <CCard>
                    <CCardBody style="    height: 210px;">
                       
                        <h5 class="font-weight-normal">
                            {{ $t('cashDrawer') }}
                        </h5>
                        <!-- <CRow>
                            <CCol lg="6">
                                <CCallout color="info" style="margin: 0.1rem 0.1rem;">
                                    <small class="text-muted mb-0">{{ $t("initialChange") }}</small>
                                    <div class="row">
                                        <strong class="col-md-12 col-sm-12 font-weight-normal text-info ">
                                            {{ getConvertCurrency(closeSellData.initialChange )}}
                                        </strong>
                                        
                                    </div>
                                </CCallout>

                            </CCol>
                            <CCol lg="6" style="margin: 0.1rem 0;">
                                
                            </CCol>
                            <CCol lg="6">
                                <CCallout color="success" style="margin: 0.1rem 0.1rem;">
                                    <small class="text-muted mb-0">{{ $t("totalCashIn") }}</small>
                                    <div class="row">
                                    <strong class="col-md-12 col-sm-12  font-weight-normal text-success  ">
                                        {{ getConvertCurrency(closeSellData.totalCashIn )}}
                                    </strong>
                                  
                                    </div>
                                </CCallout>
                            </CCol>
                            <CCol lg="6">
                                <CCallout color="danger" style="margin: 0.1rem 0.1rem;" >
                                    <small class="text-muted mb-0">{{ $t("totalCashOut") }}</small>
                                    <div class="row">
                                    <strong class="col-md-12 col-sm-12  font-weight-normal text-danger">
                                        {{ getConvertCurrency(closeSellData.totalCashOut )}}
                                    </strong>
                                   
                                    </div>
                                </CCallout>
                            </CCol>
                            <CCol lg="12">
                                <CCallout color="warning" style="margin: 0.1rem 0.1rem;" >
                                    <small class="text-muted mb-0">{{ $t("cashDrawerCount") }}</small>
                                    <div class="text-warning font-weight-bold text-center">
                                        {{ $t('actualInDrawerSh') }}:
                                        <span class="h4 text-orange">
                                        {{ getConvertCurrency(closeSellData.actualInDrawer || 0) }}
                                        </span>
                                        <small class="text-muted ml-2">
                                        / {{ getConvertCurrency(closeSellData.expectedInDrawer || 0) }} <span :class="closeSellData.difference < 0 ? 'text-danger' : 'text-info'">({{$t('difference')}} : {{ getConvertCurrency(closeSellData.difference || 0) }})</span>
                              
                                        </small>
                                    </div>
                                </CCallout>
                            </CCol>
                        </CRow> -->
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('initialChange')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.initialChange )}}
                            </strong>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('totalCashIn')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.totalCashIn )}}
                            </strong>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('totalCashOut')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.totalCashOut )}}
                            </strong>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('actualInDrawer')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.actualInDrawer )}}
                            </strong>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('expectedInDrawer')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.expectedInDrawer) }}
                            </strong>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('difference')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right" :class="closeSellData.difference < 0 ? 'text-danger' : 'text-info'">
                            <strong class="h6 " :class="closeSellData.difference < 0 ? 'text-danger' : 'text-info'">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol lg="4" md="4">
                <CCard>
                    <CCardBody style="    height: 210px;">
                        <h5 class="font-weight-normal">
                            {{ $t('payment') }}
                        </h5>
                        <!-- paymentItems -->
                        <div class="d-flex"   
                        v-for="(payment, index) in paymentItems"
                        :key="index">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                                {{ $t(getPayName(payment.paymentType) )}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(payment.inputAmount )}}
                              <!-- {{ item.paidByCash }} -->
                            </strong>
                          </div>
                        </div>
                        
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol lg="4" md="4">
                <CCard>
                    <CCardBody style="    height: 210px;">
                        <h5 class="font-weight-normal">
                            {{ $t('salesSummary') }}
                        </h5>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('netTotalIncVAT')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('netTotalNonVAT')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('netAmountVATTotal')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('vatAmount')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('roundingValue')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('forTotalPrice')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-fill">
                            <strong class="h6 text-muted">
                              {{$t('billAmount')}}
                            </strong>
                          </div>
                          <div class="flex-fill text-right">
                            <strong class="h6 text-muted">
                                {{ getConvertCurrency(closeSellData.difference) }}
                            </strong>
                          </div>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol lg="12" md="4">
                <CCard>
                    <CCardBody>
                        <NavTabs v-model="currentTab" :tabs="tabList" />
                        <div class="mt-3">
                            <div v-if="currentTab === 'bill'">
                                <CRow>
                                    <CCol lg="3">
                                        <h5 class="font-weight-normal">
                                            {{ $t('bill') }}
                                        </h5>
                                        <CChartDoughnut :datasets="billsChart.datasets" :labels="billsChart.labels"
                                        :options="doughnutOptions" />
                                    </CCol>
                                    <CCol lg="9">
                                        <!-- {{itemsBills}} -->
                                        <OrderStatusFilter :filterVal="filterVal" type="bills" @sortChange="toggleSort" />
                                        <div style="overflow-x: auto">
                                            <DataTable 
                                                :items="itemsBills"
                                                :fields="fieldsBills"
                                                hover
                                                border
                                                responsive
                                                clickableRows
                                                style="white-space: nowrap"
                                                :row-class="(item) => item._classes">

                                            </DataTable>
                                        </div>
                                    </CCol>
                                </CRow>
                               
                            </div>
                            <div v-else-if="currentTab === 'closesaleByProduct'">
                                <h5 class="font-weight-normal">
                                    {{ $t('closesaleByProduct') }}
                                </h5>
                                <DataTable
                                    style="white-space: nowrap;"
                                    :items="itemsProduct"
                                    :fields="fieldsProduct"
                                    :row-class="(item) => item._classes"
                                    hover
                                    border
                                >
                                    <template #onhandQty="{ item }">
                                        <td v-if="floatValue(item.onhandQty) < 0.00" class="text-right text-danger">{{ item.onhandQty }}</td>
                                        <td v-else class="text-right text-dark">{{ item.onhandQty }}</td>
                                    </template>
                                    <template #profit="{ item }">
                                        <td v-if="floatValue(item.profit) < 0.00" class="text-right text-danger">{{ item.profit }}</td>
                                        <td v-else class="text-right text-dark">{{ item.profit }}</td>
                                    </template>
                                </DataTable>
                            </div>
                            <div v-else-if="currentTab === 'cashInReport'">
                                <!-- <h5 class="font-weight-normal">
                                    {{ $t('cashInReport') }}
                                </h5> -->
                                <CRow>
                                    <CCol lg="3">
                                        <h5 class="font-weight-normal mb-3">
                                            {{ $t('report.txtCashInOut') }}
                                        </h5>
                                        <CChartDoughnut :datasets="cashInOutChart.datasets" :labels="cashInOutChart.labels"
                                        :options="doughnutOptions" />
                                    </CCol>
                                    <CCol lg="9">
                                        <!-- {{itemsBills}} -->
                                        <OrderStatusFilter :filterVal="filterVal" type="cash" @sortChange="toggleSort" />
                                        <div style="overflow-x: auto">
                                            <DataTable 
                                                :items="itemsCashInOUT"
                                                :fields="fieldsCashInOUT"
                                                hover
                                                border
                                                responsive
                                                clickableRows
                                                style="white-space: nowrap"
                                                :row-class="(item) => item._classes">

                                            </DataTable>
                                        </div>
                                    </CCol>
                                </CRow>
                               
                            </div>
                          
                        </div>
                    </CCardBody>
                </CCard>

            </CCol>
        </CRow>
       
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import NavTabs from '@/containers/NavTabs.vue';
import permis from '@/util/permission'
import moment from 'moment'
import OrderStatusFilter from '@/containers/OrderStatusFilter.vue';
import DataTable from "@/containers/DataTable";
import { CChartDoughnut } from "@coreui/vue-chartjs";

export default {
    components: {
        NavTabs,
        OrderStatusFilter,
        DataTable,
        CChartDoughnut
    },
    watch:{
        currentTab(newVal, oldVal){
            if(newVal !== oldVal){
                if(newVal === 'bill'){
                    this.getBills()
                }else if(newVal === 'closesaleByProduct'){
                    this.getClosesaleByProduct()
                }else if(newVal === 'cashInReport'){
                    this.getCashInOutReport()
                }else if(newVal === 'cashOutReport'){
                    this.getCashInOutReport()
                }else {
                    this.getBills()
                }
            }
        }
    },
    data() {
        return {
            data: [],
            loadingButton: true,
            meta_data: {
                last_page: null,
                current_page: 1,
                prev_page_url: null,
                items: 0,
                limit: null,
                itemCount: null,
            },
            currentTab: 'bill',
            tabList: [
                { name: 'bill', label: this.$i18n.t('bill') },
                { name: 'closesaleByProduct', label:  this.$i18n.t('closesaleByProduct') },
                { name: 'cashInReport', label: this.$i18n.t('cashInOutReport') },
                // { name: 'cashOutReport', label:this.$i18n.t('cashOutReport') },
                // { name: 'tab4', label: 'Disabled', disabled: true }
            ],
            closeSellData: {},
            paymentItems : [],
            filterVal : '',
            cashInOutReportData: [],
            billsData: [],
            closesaleByProductData : []
        }
    },
    computed: {
        ...mapGetters(['shops', 'date', 'users']),
        isExport() {
        return permis.findPermissionExport('inventory', '/inventory/stock-out')
        },
 
        itemsBills() {
            const data =  this.billsData || []
            let info = [];
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                const paymentObjectId = item.payment?.objectId ?? "-";
                const member = item.member ?? null;
                const sumdiscount = (item.discountAmount || 0) + (item.discountItem || 0);
                const promotionDiscountAmount = item.promotionDiscountAmount || 0;
                const discount = item.source === 'GRAB' 
                ? util.convertCurrency(promotionDiscountAmount) 
                : util.convertCurrency(sumdiscount);
                const netAmount = util.convertCurrency(item.netAmount || 0);
                const grandTotal = util.convertCurrency(item.grandTotal || 0);
                const receiptItems = item.receiptItems || [];

                const netTotalIncVAT = util.convertCurrency(item.netTotalIncVAT || 0);
                const netTotalNonVAT = util.convertCurrency(item.netTotalNonVAT || 0);
                const netAmountVATTotal = util.convertCurrency(item.netAmountVATTotal || 0);
                const vatAmount = util.convertCurrency(item.vatAmount || 0);
                const attach = item.attach || [];
                const deliveryFee = util.convertCurrency(item.order?.shippingCost || 0)
                const shipping = item.order?.shippingCarrier || '-'
                const source = item.source || item.order?.shippingCarrier || '-'
                // parse order
                const order = item.order || {};
                const orderNumber = order.orderNumber || "";

                let orderedAt = "";
                if (order.ordered_at != undefined) {
                orderedAt = moment(String(order.ordered_at)).format("DD MMMM YYYY H:mm:ss");
                }

                let acceptedAt = "";
                if (order.accepted_at != undefined) {
                acceptedAt = moment(String(order.accepted_at)).format("DD MMMM YYYY H:mm:ss");
                }

                let dueDate = "";
                if (order.dueDate != undefined) {
                dueDate = moment(String(order.dueDate)).format("DD MMMM YYYY H:mm:ss");
                }
                let optionPrice = 0;
                for (const receiptItem of receiptItems) {
                for (const option of receiptItem.orderedOptions || []) {
                    optionPrice += option.specialPrice || option.price || 0
                }
                }
                const optionTotal = util.convertCurrency(optionPrice)
                let shippedAt = "";
                let status = "";
                if (order.shipped_at != undefined) {
                    shippedAt = moment(String(order.shipped_at)).format("DD MMMM YYYY H:mm:ss");
                    status = this.$i18n.t("sentSuccessfully");
                }

                // Set Style
                let classess = "text-dark";
                let statusshow = this.$i18n.t("normal");
                
                if (item.receiptStatus === "V") {
                    statusshow = this.$i18n.t("cancel");
                    classess = "text-danger";
                }
                

                const serviceCharge = util.convertCurrency(item.serviceCharge || 0);
                const roundingValue = util.convertCurrency(item.roundingValue || 0);
                const payReceiptAt = moment(String(item.payReceiptAt))
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY HH:mm:ss");

                info.push({
                paymentObjectId: paymentObjectId,
                dateTime: payReceiptAt,
                receiptNumber: item.receiptNumber || "",
                netAmount: netAmount,
                discount: discount,
                grandTotal: grandTotal,
                receiptItems: receiptItems,
                netTotalIncVAT: netTotalIncVAT,
                netTotalNonVAT: netTotalNonVAT,
                netAmountVATTotal: netAmountVATTotal,
                vatAmount: vatAmount,
                orderNumber: orderNumber,
                orderedAt: orderedAt,
                shippedAt: shippedAt,
                status: status,
                acceptedAt: acceptedAt,
                dueDate: dueDate,
                receiptObjectId: item.objectId,
                roundingValue: roundingValue,
                serviceCharge: serviceCharge,
                receiptStatus: statusshow,
                _classes: classess,
                attach: attach,
                member: member,
                deliveryFee: deliveryFee,
                shipping: shipping,
                source: source,
                optionTotal: optionTotal,
                });
            }
            return info;
        },
        fieldsBills() {
            return [
                {
                key: "dateTime",
                label: this.$i18n.t("date"),
                _classes: "text-left font-weight-normal ",
                },
                {
                key: "receiptNumber",
                label: this.$i18n.t("receiptNumber"),
                _classes: "text-left font-weight-normal ",
                },
                {
                key: "grandTotal",
                label: this.$i18n.t("grandTotal"),
                _classes: "text-right font-weight-normal ",
                },
                {
                key: "orderInputType",
                lebel: this.$i18n.t("orderInputType"),
                _classes: "text-left font-weight-normal ",
                },
                {
                key:"orderType",
                lebel: this.$i18n.t("orderType"),
                _classes: "text-left font-weight-normal ",
                },
                {
                key: "receiptStatus",
                label: this.$i18n.t("status"),
                _classes: "text-left font-weight-normal ",
                },
            ];
        },
        billsChart() {
        const orderList = this.billsData || []

        const statusTotals = { A: 0, V: 0 }

        orderList.forEach(order => {
          const status = order.receiptStatus
          const netTotal = order.netTotal || 0
          if (statusTotals[status] !== undefined) {
            statusTotals[status] += netTotal
          }
        })

        const chartDataArray = [statusTotals.A, statusTotals.V]

        if (orderList.length === 0) {
          return {
            labels: [],
            datasets: [
              {
                backgroundColor: ['#5CBA96'],
                data: [0],
                borderWidth: 1,
              },
            ],
          }
        } else {
          return {
            labels: ['Active (A)', 'Voided (V)'],
            datasets: [
              {
                backgroundColor: [
                  '#4dbd74',
                  '#F6CE3B',
                ],
                data: chartDataArray,
                borderWidth: 1,
              },
            ],
          }
        }
      },

        doughnutOptions() {
            return {
                legend: { position: "bottom" },
                responsive: true,
                maintainAspectRatio: false,
            };
        },
        cashInOutChart() {
            const typeMap = {
            0: 'Cash In',
            2: 'Cash Out',
            }

            const totalsByType = {
            'Cash In': 0,
            'Cash Out': 0,
            }

            this.cashInOutReportData.forEach(item => {
            const typeLabel = typeMap[item.type]
            const amount = item.amount || 0

            if (totalsByType[typeLabel] !== undefined) {
                totalsByType[typeLabel] += amount
            }
            })

            const labels = Object.keys(totalsByType)
            const data = Object.values(totalsByType)

            return {
            labels,
            datasets: [
                {
                backgroundColor: ['#5CBA96', '#F29089'],
                data,
                borderWidth: 1,
                },
            ],
            }
        },
        itemsCashInOUT(){
            return this.cashInOutReportData.map((item) => {
                const roundBill = item.cashRound?.roundNo || '-'
                const drawerCate = item.cashRoundCategory?.name || '-'
                const descri = item.desc || '-'
                const cashRoundCategoryType = item.type === 1
                ? this.$i18n.t('cashOut')
                : this.$i18n.t('cashIn')

                const updatedBy = item.updated_by?.username || '-'
                const totalAmount = item.amount !== undefined
                ? util.convertCurrency(item.amount)
                : '0.00'

                return {
                    date: moment(String(item.created_at)).format('DD/MM/YYYY HH:mm:ss'),
                    roundBill,
                    cashRoundCategoryType,
                    drawerCate,
                    descri,
                    totalAmount,
                    updatedBy,
                }
            })
        },
        itemsProduct() {
            const data = this.closesaleByProductData
            // const start = this.meta_data.current_page * 50 - 50
            const detail = data.map((item, i) => {
                const catagory = item.category?.name || '-'
                const plu = item.productPLU?.PLUCode || '-'
                const name = item.productPLU?.name || '-'
                const cost = item.totalCost !== undefined ? util.convertCurrency(item.totalCost) : '-'
                const profit = item.profit !== undefined ? util.convertCurrency(item.profit) : '-'
                const onhandQty = (item.skuType === 'BOM' || item.skuType === 'SV')
                ? this.$t('nonStock')
                : item.onhandQty || 0

                return {
                // id: start + i + 1,
                productPLU: plu,
                name,
                category: catagory,
                quantity: item.quantity,
                onhandQty,
                cost,
                profit,
                netAmount: util.convertCurrency(item.netAmount),
                }
            })
            return detail
        },
        fieldsProduct(){
            return [
                // {
                // key: 'id',
                // label: this.$i18n.t('#'),
                // _classes: 'text-center text-dark font-weight-normal text-dark ',
                // _style: 'width:5%',
                // },
                { key: 'productPLU', label: this.$i18n.t('pluCode'), _classes: 'text-dark font-weight-normal', },
                {
                key: 'name',
                label: this.$i18n.t('productName'),
                _style: 'width:30%',
                _classes: 'text-dark font-weight-normal',
                },
                { key: 'category', label: this.$i18n.t('category'),_classes: 'text-dark font-weight-normal', },
                // {
                // key: 'quantity',
                // label: this.$i18n.t('countSales'),
                // _classes: 'text-right text-dark font-weight-normal',
                // },
                // {
                // key: 'onhandQty',
                // label: this.$i18n.t('onhandQty'),
                // _classes: 'text-right text-dark font-weight-normal',
                // },
            ]
        },
        fieldsCashInOUT(){
            return [
                {
                    key: 'date',
                    label: this.$i18n.t('date'),
                    _style: 'width:15%',
                    _classes: 'text-left text-dark font-weight-normal'
                },
                // { key: 'roundBill', 
                //     label: this.$i18n.t('billingCycle'), 
                //     _classes: 'text-center text-dark font-weight-normal',
                //     _style: 'width:8%',
                // },
                {
                    key: 'cashRoundCategoryType',
                    label: this.$i18n.t('transactionType'),
                    _classes: 'text-left text-dark font-weight-normal',
                    _style: 'width:15%',
                },
                {
                    key: 'drawerCate',
                    label: this.$i18n.t('drawerCate'),
                    _classes: 'text-left text-dark font-weight-normal',
                    _style: 'width:15%',
                },
                {
                    key: 'descri',
                    label: this.$i18n.t('detail'),
                    _classes: 'text-left text-dark font-weight-normal',
                    _style: 'width:20%',
                },
                {
                    key: 'totalAmount',
                    label: this.$i18n.t('grandTotal'),
                    _classes: 'text-right text-dark font-weight-normal',
                    _style: 'width:15%',
                },
                {
                    key: 'updatedBy',
                    label: this.$i18n.t('saveBy'),
                    _classes: 'text-left text-dark font-weight-normal',
                    _style: 'width:10%',
                },
            ]
        }
    },
    created() {
        this.getCloseSellDetailReport()
        this.getPayment()
        this.getBills()
    },

    methods: {
        ...util,
        floatValue(value) {
            return parseFloat(value)
        },
        toggleSort(key) {
            this.filterVal = key
            this.getBills();  // Send the API request only when the button is active
        },
        getConvertCurrency(amount){
            return util.convertCurrency(amount)
        },
        getFormatDate(data){
            return moment(data).format('DD/MM/YYYY HH:mm:ss')
        },
        getPayName(payment){
            return util.getPaymentName(payment)
        },
        getCloseSellDetailReport() {
          let data = {
                _id: "677796253514ff262dd67e13",
                objectId: "677796255e85b2000032e270",
                actualInDrawer: 415,
                created_at: "2025-01-03T07:47:49.112Z",
                created_by: {
                    objectId: "2312081605IxpN9woVhXmbH8spUTLQ",
                    id: "User001",
                    username: "Admin"
                },
                created_by_id: "User001",
                difference: 0,
                drawerId: "NFVXS",
                expectedInDrawer: 415,
                id: "2501031447AHF9DgMEPcpRgJ6OhbR3",
                initialChange: 100,
                openAt: "2025-01-03T07:47:49.112Z",
                pos: {
                    id: "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                    posNumber: "001",
                    objectId: "2312081605quTfpsK4voILpnBB1D76"
                },
                posId: "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                roundNo: "1",
                serverTimestamp: "2025-01-22T02:23:28.222Z",
                shop: {
                    objectId: "2312081605FSqK8oyj9PfeDvnyhI2w",
                    branchName: "บางหว้า",
                    id: "17051009557cp0Nc38fHLnt3dst465"
                },
                shopId: "17051009557cp0Nc38fHLnt3dst465",
                status: "A",
                totalCashIn: 50,
                totalCashOut: 10,
                totalCashSales: 190,
                uid: "EYT3WDTPoDWbesowbdhMNVVRlmD2",
                updated_at: "2025-01-22T02:23:28.089Z",
                updated_by: {
                    username: "Admin",
                    id: "User001",
                    objectId: "2312081605IxpN9woVhXmbH8spUTLQ"
                },
                updated_by_id: "User001",
                closeAt: "2025-01-22T02:23:28.089Z",
                CashInOutItem: [
                    {
                    _id: "6790568d3514ff262d582354",
                    objectId: "6790568d6947120000b7034a",
                    amount: 50,
                    cashRound: {
                        updated_by_id: "User001",
                        drawerId: "NFVXS",
                        status: "T",
                        id: "2501031447AHF9DgMEPcpRgJ6OhbR3",
                        initialChange: 100,
                        roundNo: "1",
                        totalCashSales: 275,
                        objectId: "677796255e85b2000032e270",
                        actualInDrawer: 0,
                        totalCashIn: 50,
                        difference: 0,
                        expectedInDrawer: 425,
                        totalCashOut: 0
                    },
                    cashRoundCategory: {
                        id: "2001231649l4jBpSsiqShp1thAMf2F",
                        objectId: "2312081652BOBBhHs0LYZ9qZwjMGgW",
                        name: "โบนัส",
                        type: 0
                    },
                    cashRoundCategoryId: "2001231649l4jBpSsiqShp1thAMf2F",
                    cashRoundId: "2501031447AHF9DgMEPcpRgJ6OhbR3",
                    created_at: "2025-01-22T02:23:09.522Z",
                    created_by: {
                        id: "User001",
                        objectId: "2312081605IxpN9woVhXmbH8spUTLQ",
                        username: "Admin"
                    },
                    created_by_id: "User001",
                    desc: "",
                    id: "25012209231awXbEcPv26RCCwKo0Lx",
                    pos: {
                        posNumber: "001",
                        objectId: "2312081605quTfpsK4voILpnBB1D76",
                        id: "1705100955yrSFGajIQ7Cqdj5UC1Ry"
                    },
                    posId: "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                    serverTimestamp: "2025-01-22T02:23:09.662Z",
                    shop: {
                        objectId: "2312081605FSqK8oyj9PfeDvnyhI2w",
                        branchName: "บางหว้า",
                        id: "17051009557cp0Nc38fHLnt3dst465"
                    },
                    shopId: "17051009557cp0Nc38fHLnt3dst465",
                    type: 0,
                    uid: "EYT3WDTPoDWbesowbdhMNVVRlmD2",
                    updated_at: "2025-01-22T02:23:09.522Z",
                    updated_by: {
                        username: "Admin",
                        id: "User001",
                        objectId: "2312081605IxpN9woVhXmbH8spUTLQ"
                    },
                    updated_by_id: "User001"
                    },
                    {
                    _id: "679056963514ff262d58238d",
                    objectId: "679056957b14a100005d4a03",
                    amount: 10,
                    cashRound: {
                        roundNo: "1",
                        actualInDrawer: 0,
                        status: "T",
                        drawerId: "NFVXS",
                        initialChange: 100,
                        updated_by_id: "User001",
                        totalCashOut: 10,
                        difference: 0,
                        objectId: "677796255e85b2000032e270",
                        id: "2501031447AHF9DgMEPcpRgJ6OhbR3",
                        totalCashIn: 50,
                        expectedInDrawer: 415,
                        totalCashSales: 275
                    },
                    cashRoundCategory: {
                        objectId: "23120816526NnoDmye7QpibdaDbEVG",
                        id: "2001231650TRPYKjeXzJyd3c9ZCkVf",
                        name: "ซื้อของเข้า",
                        type: 1
                    },
                    cashRoundCategoryId: "2001231650TRPYKjeXzJyd3c9ZCkVf",
                    cashRoundId: "2501031447AHF9DgMEPcpRgJ6OhbR3",
                    created_at: "2025-01-22T02:23:17.955Z",
                    created_by: {
                        username: "Admin",
                        id: "User001",
                        objectId: "2312081605IxpN9woVhXmbH8spUTLQ"
                    },
                    created_by_id: "User001",
                    desc: "",
                    id: "2501220923QcwBsj5FO2FBjhp9K3zH",
                    pos: {
                        id: "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                        objectId: "2312081605quTfpsK4voILpnBB1D76",
                        posNumber: "001"
                    },
                    posId: "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                    serverTimestamp: "2025-01-22T02:23:18.110Z",
                    shop: {
                        branchName: "บางหว้า",
                        id: "17051009557cp0Nc38fHLnt3dst465",
                        objectId: "2312081605FSqK8oyj9PfeDvnyhI2w"
                    },
                    shopId: "17051009557cp0Nc38fHLnt3dst465",
                    type: 1,
                    uid: "EYT3WDTPoDWbesowbdhMNVVRlmD2",
                    updated_at: "2025-01-22T02:23:17.955Z",
                    updated_by: {
                        id: "User001",
                        objectId: "2312081605IxpN9woVhXmbH8spUTLQ",
                        username: "Admin"
                    },
                    updated_by_id: "User001"
                    }
                ]
                }
            this.closeSellData = data
        },
        getPayment(){
            let paymentItems =[
                {
                    paymentType: 0,
                    EDCVoidedFieldData: {},
                    created_at: "2025-03-17T10:58:08.897Z",
                    inputAmount: 500,
                    updated_at: "2025-03-17T10:58:08.897Z",
                    created_by: {
                    username: "Admin",
                    objectId: "2312081605IxpN9woVhXmbH8spUTLQ",
                    id: "User001"
                    },
                    updated_by_id: "User001",
                    updated_by: {
                    objectId: "2312081605IxpN9woVhXmbH8spUTLQ",
                    username: "Admin",
                    id: "User001"
                    },
                    id: "2503171758awtRu7Xi0kvM8hh7L5fLkO",
                    sequene: 0,
                    EDCFieldData: {},
                    created_by_id: "User001",
                    cashDeposit: 0,
                    amount: 410
                }
                ]
            this.paymentItems = paymentItems
        },
        getBills(){
            let billsData = [
                {
                    "_id": "67c047f3ce26dc996cf74607",
                    "objectId": "1740654579415tzlPdqBOglXx",
                    "beforeGP": 113,
                    "campaigns": [
                    {
                        "id": "GFSBPOS-860-816-C643T6LFPA31BA-49913820",
                        "name": "ลด ฿9 สำหรับคำสั่งซื้อที่มียอดขั้นต่ำ ฿1",
                        "deductedAmount": 9,
                        "deductedPart": "basket_amount",
                        "appliedItemIDs": null,
                        "level": "order",
                        "mexFundedRatio": 100,
                        "type": "percentage",
                        "usageCount": 1,
                        "campaignNameForMex": "ส่วนลดใบเสร็จ 7%"
                    }
                    ],
                    "created_at": "2025-02-27T11:09:39.000Z",
                    "discountAmount": 0,
                    "discountItem": 0,
                    "dueDate": "2025-02-27T12:09:39.358Z",
                    "gpAmount": 33.9,
                    "gpPercent": 30,
                    "gpTotal": 36.269999999999996,
                    "gpVAT": 2.37,
                    "grandTotal": 113,
                    "id": "1740654579415pcSprE3Wya5f",
                    "isVATIncluded": true,
                    "netAmount": 122,
                    "netAmountIncServiceCharge": 0,
                    "netAmountIncVAT": 102,
                    "netAmountNonVAT": 0,
                    "netAmountVATTotal": 86.91588785046729,
                    "netProfit": -247,
                    "netTotal": 93,
                    "netTotalIncVAT": 93,
                    "netTotalNonVAT": 0,
                    "numCust": 1,
                    "order": {
                    "shippingCost": 10,
                    "shippingCarrier": "GRAB",
                    "ordered_at": "2025-02-27T11:09:39.000Z",
                    "orderInputType": "GRAB",
                    "orderStatus": "CANCEL",
                    "id": "174065457944431TV9Z3eyXTP",
                    "orderNumber": "GF-8311",
                    "receiptId": "1740654579415pcSprE3Wya5f",
                    "tracking": [
                        {
                        "date": "2025-02-27T11:09:39.000Z",
                        "status": "NEW",
                        "message": "Order received from Grab"
                        },
                        {
                        "status": "ACCEPT",
                        "timestamp": "2025-02-27T11:09:45.352Z",
                        "message": "Order Accepted"
                        },
                        {
                        "status": "PREPARE",
                        "timestamp": "2025-02-27T11:09:45.352Z",
                        "message": "Order Preparing"
                        },
                        {
                        "date": "2025-02-27T11:09:52.105Z",
                        "status": "DRIVER_ALLOCATED",
                        "message": "Driver has been allocated"
                        },
                        {
                        "date": "2025-02-28T06:54:02.452Z",
                        "status": "CANCELLED",
                        "message": "Order has been cancelled by the consumer, merchant, or driver for some reason"
                        }
                    ],
                    "dueDate": "2025-02-27T12:09:39.358Z",
                    "estimatedReadyTime": "2025-02-27T11:19:39.358Z",
                    "cutlery": false,
                    "viewOrderAt": "2025-02-27T11:09:42.826Z",
                    "accepted_at": "2025-02-27T11:09:45.369Z",
                    "canceled_at": "2025-02-28T06:54:02.452Z"
                    },
                    "orderNo": "123456789-C7AGLUM3GZBYGX",
                    "productPRUType": {
                    "id": "101",
                    "objectId": "6577c9286450140000f28650",
                    "name": "Grab"
                    },
                    "productPRUTypeId": "101",
                    "promotionDiscountAmount": 9,
                    "providerDiscountAmount": 0,
                    "quantityIncVAT": 1,
                    "quantityNonVAT": 0,
                    "queueIndex": 0,
                    "receiptItems": [
                    {
                        "discountBillPerQty": 0,
                        "source": "GRAB",
                        "productPLUId": "6683bc3ec1770e001347b171",
                        "receiptId": "",
                        "categoryName": "ไม่รู้",
                        "serviceCharge": false,
                        "orderedOptions": [
                        {
                            "activeOptionId": "2501280931DeE6q399QUfoLJJS0DD5",
                            "price": 20,
                            "objectId": "1740654579449ucGl6UWIuUYP",
                            "optionGroup": {
                            "id": "6756b2616f527a0012f1f957",
                            "objectId": "6756b2616f527a0012f1f956",
                            "name": "ท๊อปปิ้ง"
                            },
                            "optionProductPLUs": [],
                            "itemInGroupId": "6756b2616f527a0012f1f957",
                            "optionItemName": "เฉาก๊วย",
                            "optionItem": {
                            "id": "668798c79eda750014680e17",
                            "objectId": "668798c79eda750014680e16",
                            "name": "เฉาก๊วย"
                            },
                            "quantity": 1,
                            "optionItemId": "668798c79eda750014680e17",
                            "id": "1740654579449uhjLNSy6CmFq",
                            "receiptItemId": "1740654579444AEP87VlcvyhD",
                            "cost": 0,
                            "specialPrice": 20,
                            "totalOptionCost": 0,
                            "orderIndex": 1
                        }
                        ],
                        "SKUStock": {
                        "id": "6683bc3ec1770e001347b16f",
                        "objectId": "6683bc3ec1770e001347b16e",
                        "store": {
                            "id": "ST001",
                            "objectId": "23120816523AEH20yE426Ae7KSyYM2",
                            "name": "ขายหน้าร้าน"
                        }
                        },
                        "totalAmount": 122,
                        "SKUStockId": "6683bc3ec1770e001347b16f",
                        "created_at": "2025-02-27T11:09:39.444Z",
                        "gpTotal": 39.160000000000004,
                        "created_by": {
                        "id": "SYSTEMAUTOMATION001",
                        "objectId": "m29ulp4zIOEAyPkbMho9MBAxm",
                        "username": "SYSTEM_AUTOMATION"
                        },
                        "gpVAT": 2.56,
                        "unit": "แก้ว",
                        "cost": 340,
                        "categoryId": "6683bc3ec1770e001347b0fa",
                        "skuType": "BOM",
                        "isPrintToKitchen": false,
                        "productSKU": {
                        "id": "AA009",
                        "objectId": "6683bc3ec1770e001347b16d",
                        "name": null
                        },
                        "remoteImagePath": "https://firebasestorage.googleapis.com/v0/b/silompos-dev.appspot.com/o/resources%2FEYT3WDTPoDWbesowbdhMNVVRlmD2%2Fresources%2Fproducts%2F6683bc3ec1770e001347b16d%2F1719911597615-alg6811llokorhzc.png?alt=media&token=e37c948b-0c8e-4b65-9abe-f89b50131fc8",
                        "pluName": "ชามะนาวโซดา",
                        "discountAmount": 0,
                        "id": "1740654579444AEP87VlcvyhD",
                        "beforeGP": 122,
                        "productSKUId": "AA009",
                        "quantitySKU": 1,
                        "netAmount": 102,
                        "totalCost": 340,
                        "quantity": 1,
                        "gpAmount": 36.6,
                        "price": 102,
                        "indexSequence": 1,
                        "ratio": 1,
                        "vatType": "V",
                        "orderedBOMs": [
                        {
                            "pluName": "ขนมเปี๊ยะไข่เค็มลาวา( Chinese Pastry Salted Egg Yolks Lava)",
                            "quantity": 1,
                            "productPLU": {
                            "id": "6683bc3ec1770e001347b1a1",
                            "name": "ขนมเปี๊ยะไข่เค็มลาวา( Chinese Pastry Salted Egg Yolks Lava)",
                            "objectId": "6683bc3ec1770e001347b1a0"
                            },
                            "objectId": "67a477dc3f0d8200133088c0",
                            "ratio": 1,
                            "receiptItemId": "6683bc3ec1770e001347b170",
                            "id": "67a477dc3f0d8200133088c1",
                            "productPLUId": "6683bc3ec1770e001347b1a1"
                        },
                        {
                            "pluName": "คุกกี้เนยสด (Pure Butter Cookies)",
                            "quantity": 1,
                            "productPLU": {
                            "id": "6683bc3ec1770e001347b1aa",
                            "name": "คุกกี้เนยสด (Pure Butter Cookies)",
                            "objectId": "6683bc3ec1770e001347b1a9"
                            },
                            "objectId": "67a477dc3f0d8200133088c2",
                            "ratio": 1,
                            "receiptItemId": "6683bc3ec1770e001347b170",
                            "id": "67a477dc3f0d8200133088c3",
                            "productPLUId": "6683bc3ec1770e001347b1aa"
                        },
                        {
                            "pluName": "บลูเบอรี่ชีสพาย (Blueberry Cheese Pie)",
                            "quantity": 1,
                            "productPLU": {
                            "id": "6683bc3ec1770e001347b1b3",
                            "name": "บลูเบอรี่ชีสพาย (Blueberry Cheese Pie)",
                            "objectId": "6683bc3ec1770e001347b1b2"
                            },
                            "objectId": "67a477dc3f0d8200133088c4",
                            "ratio": 1,
                            "receiptItemId": "6683bc3ec1770e001347b170",
                            "id": "67a477dc3f0d8200133088c5",
                            "productPLUId": "6683bc3ec1770e001347b1b3"
                        },
                        {
                            "pluName": "นม",
                            "quantity": 1,
                            "productPLU": {
                            "id": "6683bc3ec1770e001347b117",
                            "name": "นม",
                            "objectId": "6683bc3ec1770e001347b116"
                            },
                            "objectId": "67a5af109228c2001231aedf",
                            "ratio": 1,
                            "receiptItemId": "6683bc3ec1770e001347b170",
                            "id": "67a5af109228c2001231aee0",
                            "productPLUId": "6683bc3ec1770e001347b117"
                        },
                        {
                            "pluName": "โดนัทนมสด (Donut)",
                            "quantity": 1,
                            "productPLU": {
                            "id": "6683bc3ec1770e001347b1bc",
                            "name": "โดนัทนมสด (Donut)",
                            "objectId": "6683bc3ec1770e001347b1bb"
                            },
                            "objectId": "67a5af109228c2001231aee1",
                            "ratio": 1,
                            "receiptItemId": "6683bc3ec1770e001347b170",
                            "id": "67a5af109228c2001231aee2",
                            "productPLUId": "6683bc3ec1770e001347b1bc"
                        }
                        ],
                        "totalDiscountBill": 0,
                        "gpPercent": 30,
                        "status": "C",
                        "stdCost": 340,
                        "created_by_id": "SYSTEMAUTOMATION001",
                        "productPLU": {
                        "id": "6683bc3ec1770e001347b171",
                        "objectId": "6683bc3ec1770e001347b170",
                        "name": "ชามะนาวโซดา",
                        "PLUCode": "13",
                        "SKURatio": 1
                        },
                        "category": {
                        "id": "6683bc3ec1770e001347b0fa",
                        "objectId": "6683bc3ec1770e001347b0f9",
                        "name": "ไม่รู้"
                        },
                        "indexColor": 1,
                        "pluCode": "13",
                        "grabItemID": "THITE20250227110939223725",
                        "note": "",
                        "updated_at": "2025-02-27T11:09:39.444Z",
                        "outOfStockInstruction": null,
                        "cancelled_at": "2025-02-28T06:54:02.452Z"
                    }
                    ],
                    "receiptNumber": "GRB000026",
                    "receiptStatus": "V",
                    "remark": "GF-8311",
                    "roundingValue": 0,
                    "serviceCharge": 0,
                    "serviceChargePercent": 0,
                    "source": "GRAB",
                    "totalCost": 340,
                    "totalOptionCost": 0,
                    "typeOfOrder": 4,
                    "uid": "EYT3WDTPoDWbesowbdhMNVVRlmD2",
                    "updated_at": "2025-02-28T06:54:02.582Z",
                    "vatAmount": 6.084112149532714,
                    "vatBase": 7,
                    "close": "2025-02-27T16:59:59.999Z",
                    "date": "2025-02-26T17:00:00.000Z",
                    "dateString": "2025-02-27",
                    "open": "2025-02-26T17:00:00.000Z",
                    "payReceiptAt": "2025-02-27T11:09:39.000Z",
                    "payment": {
                    "change": 0,
                    "id": "67c047f36070d80013ebf3c0",
                    "paid": 113,
                    "objectId": "67c047f36070d80013ebf3bf"
                    },
                    "cancelledDate": "2025-02-28T06:54:02.582Z",
                    "cancelled_by": {
                    "id": "SYSTEMAUTOMATION001",
                    "objectId": "m29ulp4zIOEAyPkbMho9MBAxm",
                    "username": "SYSTEM_AUTOMATION"
                    },
                    "cancelled_by_id": "SYSTEMAUTOMATION001",
                    "kdsEnd": "2025-03-24T02:52:30.810Z"
                },
                {
                    "_id": "67c04787ce26dc996cf74061",
                    "objectId": "17406544719239sn4gqurxxOM",
                    "beforeGP": 139,
                    "campaigns": [
                    {
                        "id": "GFSBPOS-860-816-C643T6LFPA31BA-49913820",
                        "name": "ลด ฿11 สำหรับคำสั่งซื้อที่มียอดขั้นต่ำ ฿1",
                        "deductedAmount": 11,
                        "deductedPart": "basket_amount",
                        "appliedItemIDs": null,
                        "level": "order",
                        "mexFundedRatio": 100,
                        "type": "percentage",
                        "usageCount": 1,
                        "campaignNameForMex": "ส่วนลดใบเสร็จ 7%"
                    }
                    ],
                    "created_at": "2025-02-27T11:07:51.000Z",
                    "discountAmount": 0,
                    "discountItem": 0,
                    "dueDate": "2025-02-27T12:07:51.860Z",
                    "gpAmount": 41.699999999999996,
                    "gpPercent": 30,
                    "gpTotal": 44.62,
                    "gpVAT": 2.92,
                    "grandTotal": 139,
                    "id": "1740654471923QA6SzA9s8QHP",
                    "isVATIncluded": true,
                    "netAmount": 150,
                    "netAmountIncServiceCharge": 0,
                    "netAmountIncVAT": 134,
                    "netAmountNonVAT": 0,
                    "netAmountVATTotal": 114.95327102803738,
                    "netProfit": 99.5,
                    "netTotal": 123,
                    "netTotalIncVAT": 123,
                    "netTotalNonVAT": 0,
                    "numCust": 1,
                    "order": {
                    "shippingCost": 10,
                    "shippingCarrier": "GRAB",
                    "ordered_at": "2025-02-27T11:07:51.000Z",
                    "orderInputType": "GRAB",
                    "orderStatus": "FINISH",
                    "id": "17406544719437VF4jmKntRiq",
                    "orderNumber": "GF-9602",
                    "receiptId": "1740654471923QA6SzA9s8QHP",
                    "tracking": [
                        {
                        "date": "2025-02-27T11:07:51.000Z",
                        "status": "NEW",
                        "message": "Order received from Grab"
                        },
                        {
                        "status": "ACCEPT",
                        "timestamp": "2025-02-27T11:07:58.076Z",
                        "message": "Order Accepted"
                        },
                        {
                        "status": "PREPARE",
                        "timestamp": "2025-02-27T11:07:58.076Z",
                        "message": "Order Preparing"
                        },
                        {
                        "date": "2025-02-27T11:08:22.420Z",
                        "status": "DRIVER_ALLOCATED",
                        "message": "Driver has been allocated"
                        },
                        {
                        "date": "2025-02-27T11:08:40.330Z",
                        "status": "DRIVER_ARRIVED",
                        "message": "Driver has reached your store to collect the order"
                        },
                        {
                        "date": "2025-02-27T11:08:54.892Z",
                        "status": "COLLECTED",
                        "message": "Driver has collected the order from your store"
                        },
                        {
                        "date": "2025-02-27T11:09:15.644Z",
                        "status": "DELIVERED",
                        "message": "Driver has delivered the order to the consumer location"
                        }
                    ],
                    "dueDate": "2025-02-27T12:07:51.860Z",
                    "estimatedReadyTime": "2025-02-27T11:17:51.860Z",
                    "cutlery": false,
                    "viewOrderAt": "2025-02-27T11:07:56.933Z",
                    "accepted_at": "2025-02-27T11:07:58.093Z",
                    "shipped_at": "2025-02-27T11:08:54.892Z",
                    "finished_at": "2025-02-27T11:09:15.644Z"
                    },
                    "orderNo": "123456789-C7AGLUDUT2CJTJ",
                    "productPRUType": {
                    "id": "101",
                    "objectId": "6577c9286450140000f28650",
                    "name": "Grab"
                    },
                    "productPRUTypeId": "101",
                    "promotionDiscountAmount": 11,
                    "providerDiscountAmount": 0,
                    "quantityIncVAT": 1,
                    "quantityNonVAT": 0,
                    "queueIndex": 0,
                    "receiptItems": [
                    {
                        "discountBillPerQty": 0,
                        "source": "GRAB",
                        "productPLUId": "6683bc3ec1770e001347b144",
                        "receiptId": "",
                        "categoryName": "ไม่รู้",
                        "serviceCharge": false,
                        "orderedOptions": [
                        {
                            "activeOptionId": "2501280932rtKgkbDgZffjs8IDSLqT",
                            "price": 16,
                            "objectId": "1740654471946tcg6Xd5r2rdf",
                            "optionGroup": {
                            "id": "6756b2616f527a0012f1f957",
                            "objectId": "6756b2616f527a0012f1f956",
                            "name": "ท๊อปปิ้ง"
                            },
                            "optionProductPLUs": [],
                            "itemInGroupId": "6756b2616f527a0012f1f957",
                            "optionItemName": "ไข่มุก",
                            "optionItem": {
                            "id": "668798999eda750014680e15",
                            "objectId": "668798999eda750014680e14",
                            "name": "ไข่มุก"
                            },
                            "quantity": 1,
                            "optionItemId": "668798999eda750014680e15",
                            "id": "1740654471946d4EP9bZ9R8Dx",
                            "receiptItemId": "1740654471943Vygkd8fY3pIv",
                            "cost": 0,
                            "specialPrice": 16,
                            "totalOptionCost": 0,
                            "orderIndex": 1
                        }
                        ],
                        "SKUStock": {
                        "id": "6683bc3ec1770e001347b142",
                        "objectId": "6683bc3ec1770e001347b141",
                        "store": {
                            "id": "ST001",
                            "objectId": "23120816523AEH20yE426Ae7KSyYM2",
                            "name": "ขายหน้าร้าน"
                        }
                        },
                        "totalAmount": 150,
                        "SKUStockId": "6683bc3ec1770e001347b142",
                        "created_at": "2025-02-27T11:07:51.943Z",
                        "gpTotal": 48.15,
                        "created_by": {
                        "id": "SYSTEMAUTOMATION001",
                        "objectId": "m29ulp4zIOEAyPkbMho9MBAxm",
                        "username": "SYSTEM_AUTOMATION"
                        },
                        "gpVAT": 3.15,
                        "unit": "แก้ว",
                        "cost": 23.5,
                        "categoryId": "6683bc3ec1770e001347b0fa",
                        "skuType": "BOM",
                        "isPrintToKitchen": true,
                        "productSKU": {
                        "id": "AA004",
                        "objectId": "6683bc3ec1770e001347b140",
                        "name": null
                        },
                        "remoteImagePath": "https://firebasestorage.googleapis.com/v0/b/silompos-dev.appspot.com/o/resources%2FEYT3WDTPoDWbesowbdhMNVVRlmD2%2Fresources%2Fproducts%2F6683bc3ec1770e001347b140%2F1719911440370-i1gmds5rm8k2kr9l.png?alt=media&token=261994d4-4606-4b0c-b5b0-da1b0fcb6dc2",
                        "pluName": "คาปูฃิโน่",
                        "discountAmount": 0,
                        "id": "1740654471943Vygkd8fY3pIv",
                        "beforeGP": 150,
                        "productSKUId": "AA004",
                        "quantitySKU": 1,
                        "netAmount": 134,
                        "totalCost": 23.5,
                        "quantity": 1,
                        "gpAmount": 45,
                        "price": 134,
                        "indexSequence": 1,
                        "ratio": 1,
                        "vatType": "V",
                        "orderedBOMs": [
                        {
                            "pluName": "นม",
                            "quantity": 2,
                            "productPLU": {
                            "id": "6683bc3ec1770e001347b111",
                            "name": "นม",
                            "objectId": "6683bc3ec1770e001347b110"
                            },
                            "objectId": "668799620216ae00138da04f",
                            "ratio": 0.5,
                            "receiptItemId": "6683bc3ec1770e001347b143",
                            "id": "668799620216ae00138da050",
                            "productPLUId": "6683bc3ec1770e001347b111"
                        },
                        {
                            "pluName": "น้ำตาล",
                            "quantity": 0.1,
                            "productPLU": {
                            "id": "66879b219eda750014680e25",
                            "name": "น้ำตาล",
                            "objectId": "66879b219eda750014680e24"
                            },
                            "objectId": "66879b439eda750014680e2c",
                            "ratio": 10,
                            "receiptItemId": "6683bc3ec1770e001347b143",
                            "id": "66879b439eda750014680e2d",
                            "productPLUId": "66879b219eda750014680e25"
                        }
                        ],
                        "totalDiscountBill": 0,
                        "gpPercent": 30,
                        "status": "S",
                        "stdCost": 23.5,
                        "created_by_id": "SYSTEMAUTOMATION001",
                        "productPLU": {
                        "id": "6683bc3ec1770e001347b144",
                        "objectId": "6683bc3ec1770e001347b143",
                        "name": "คาปูฃิโน่",
                        "PLUCode": "8",
                        "SKURatio": 1
                        },
                        "category": {
                        "id": "6683bc3ec1770e001347b0fa",
                        "objectId": "6683bc3ec1770e001347b0f9",
                        "name": "ไม่รู้"
                        },
                        "indexColor": 1,
                        "pluCode": "8",
                        "grabItemID": "THITE20250227110751426340",
                        "note": "",
                        "updated_at": "2025-03-24T02:52:28.797Z",
                        "outOfStockInstruction": null
                    }
                    ],
                    "receiptNumber": "GRB000025",
                    "receiptStatus": "A",
                    "remark": "GF-9602",
                    "roundingValue": 0,
                    "serviceCharge": 0,
                    "serviceChargePercent": 0,
                    "source": "GRAB",
                    "totalCost": 23.5,
                    "totalOptionCost": 0,
                    "typeOfOrder": 4,
                    "uid": "EYT3WDTPoDWbesowbdhMNVVRlmD2",
                    "updated_at": "2025-02-27T11:09:15.644Z",
                    "vatAmount": 8.046728971962622,
                    "vatBase": 7,
                    "close": "2025-02-27T16:59:59.999Z",
                    "date": "2025-02-26T17:00:00.000Z",
                    "dateString": "2025-02-27",
                    "open": "2025-02-26T17:00:00.000Z",
                    "payReceiptAt": "2025-02-27T11:07:51.000Z",
                    "payment": {
                    "change": 0,
                    "id": "67c047876070d80013ebf3a2",
                    "paid": 139,
                    "objectId": "67c047876070d80013ebf3a1"
                    },
                    "kdsEnd": "2025-03-24T02:52:30.014Z"
                }
            ]
            this.billsData =   billsData         
        },
        getClosesaleByProduct(){
            let data = [
            {
            "pluCode": "S02",
            "quantity": 5,
            "onhandQty": 5,
            "totalAmount": 600,
            "netAmount": 600,
            "totalCost": 350,
            "profit": 250,
            "productPLU": {
                "id": "202503240332193YGFmrIQjTX",
                "name": "เฟรนฟราย",
                "unit": {
                "id": "67dced9c240e7d00120189af",
                "name": "จาน",
                "objectId": "67dced9c240e7d00120189b0"
                },
                "PLUCode": "S02",
                "objectId": "20250324033219Fa7LpqWF201",
                "SKURatio": 1
            },
            "ratio": 1,
            "category": {
                "id": "67dced62278d52001345632b",
                "name": "ของทานเล่น",
                "objectId": "67dced62278d52001345632c"
            },
            "unit": "จาน",
            "price": 120,
            "skuType": "P"
            },
            {
            "pluCode": "D01",
            "quantity": 4,
            "onhandQty": 56,
            "totalAmount": 360,
            "netAmount": 360,
            "totalCost": 280,
            "profit": 80,
            "productPLU": {
                "id": "202503210454558vM5iUg8t2f",
                "SKURatio": 1,
                "PLUCode": "D01",
                "unit": {
                "name": "แก้ว",
                "id": "29",
                "objectId": "67dcda073782b60000575046"
                },
                "name": "Americano",
                "objectId": "20250321045455P7LwyJNjtAL"
            },
            "ratio": 1,
            "category": {
                "objectId": "67dcecf5bc2a400013799b22",
                "name": "เครื่องดื่ม",
                "id": "67dcecf5bc2a400013799b21"
            },
            "unit": "แก้ว",
            "price": 90,
            "skuType": "P"
            }
            ]
            this.closesaleByProductData = data
        },
        getCashInOutReport(){
            let data =[ 
                 {
                "_id": "67e25435ce26dc996c0ae25a",
                "objectId": "67e25435d76a350000e18faa",
                "amount": 500,
                "cashRound": {
                    "drawerId": "ALYOJ",
                    "totalCashOut": 0,
                    "totalCashSales": 0,
                    "difference": 0,
                    "id": "2503251357BhhgX1tD0ubBvyoobNdo",
                    "roundNo": "1",
                    "initialChange": 500,
                    "status": "T",
                    "totalCashIn": 500,
                    "updated_by_id": "User001",
                    "actualInDrawer": 0,
                    "expectedInDrawer": 1000,
                    "objectId": "67e253d96a785c0000debff9"
                },
                "cashRoundCategory": {
                    "objectId": "67dcda0f14585600005a7989",
                    "id": "20012316493vt2JqBXGN6rVnhoXUqD",
                    "type": 0,
                    "name": "ค่าขายสินค้า"
                },
                "cashRoundCategoryId": "20012316493vt2JqBXGN6rVnhoXUqD",
                "cashRoundId": "2503251357BhhgX1tD0ubBvyoobNdo",
                "created_at": "2025-03-25T06:59:01.146Z",
                "created_by": {
                    "username": "Admin",
                    "id": "User001",
                    "objectId": "67dcda07e7da7f0000a3c5bc"
                },
                "created_by_id": "User001",
                "desc": "",
                "id": "2503251359NNvrK7TdI6nS2eeCiXlf",
                "pos": {
                    "id": "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                    "posNumber": "001",
                    "objectId": "67dcda053f954d0000982dd4"
                },
                "posId": "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                "serverTimestamp": "2025-03-25T06:59:01.374Z",
                "shop": {
                    "id": "17051009557cp0Nc38fHLnt3dst465",
                    "branchName": "Headquarters",
                    "objectId": "67dcda0525aaba0000cedc8a"
                },
                "shopId": "17051009557cp0Nc38fHLnt3dst465",
                "type": 0,
                "uid": "UcCuiI8oNUVIKqJil0JsTMZ2R3R2",
                "updated_at": "2025-03-25T06:59:01.146Z",
                "updated_by": {
                    "id": "User001",
                    "username": "Admin",
                    "objectId": "67dcda07e7da7f0000a3c5bc"
                },
                "updated_by_id": "User001"
                },
                {
                "_id": "67e27a8ace26dc996c0c5a14",
                "objectId": "67e27a8aafac840000d02cf3",
                "amount": 7,
                "cashRound": {
                    "expectedInDrawer": 1070,
                    "roundNo": "3",
                    "updated_by_id": "User001",
                    "status": "T",
                    "totalCashIn": 317,
                    "totalCashOut": 437,
                    "difference": 0,
                    "objectId": "67e25c1917296a0000ddd84a",
                    "drawerId": "HIPLU",
                    "initialChange": 1000,
                    "totalCashSales": 190,
                    "id": "2503251432OSukEBszPKb4rQ4tIRAZ",
                    "actualInDrawer": 0
                },
                "cashRoundCategory": {
                    "id": "2001231650B54gZ7B4H2nGIC4gPBCF",
                    "objectId": "67dcda0fc685d50000cfc012",
                    "name": "ค่าพาหนะ",
                    "type": 1
                },
                "cashRoundCategoryId": "2001231650B54gZ7B4H2nGIC4gPBCF",
                "cashRoundId": "2503251432OSukEBszPKb4rQ4tIRAZ",
                "created_at": "2025-03-25T09:42:34.643Z",
                "created_by": {
                    "id": "User001",
                    "objectId": "67dcda07e7da7f0000a3c5bc",
                    "username": "Admin"
                },
                "created_by_id": "User001",
                "desc": "",
                "id": "2503251642REmvcEMOnCHFwycDQDvR",
                "pos": {
                    "objectId": "67dcda053f954d0000982dd4",
                    "id": "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                    "posNumber": "001"
                },
                "posId": "1705100955yrSFGajIQ7Cqdj5UC1Ry",
                "serverTimestamp": "2025-03-25T09:42:34.802Z",
                "shop": {
                    "objectId": "67dcda0525aaba0000cedc8a",
                    "id": "17051009557cp0Nc38fHLnt3dst465",
                    "branchName": "Headquarters"
                },
                "shopId": "17051009557cp0Nc38fHLnt3dst465",
                "type": 1,
                "uid": "UcCuiI8oNUVIKqJil0JsTMZ2R3R2",
                "updated_at": "2025-03-25T09:42:34.643Z",
                "updated_by": {
                    "objectId": "67dcda07e7da7f0000a3c5bc",
                    "username": "Admin",
                    "id": "User001"
                },
                "updated_by_id": "User001"
                }
            ]
            this.cashInOutReportData = data
        },
    }
}
</script>
